module.exports = __webpack_public_path__ + "8a5c0ceba45bfe43a7842d83a05f8414.svg";